export default __webpack_public_path__ + "static/media/hard.f7080769.svg";